<template>
  <section>
    <visits v-if="ready" />
    <shortcodes />
    <b-row class="match-height">
      <b-col lg="6">
        <channels />
      </b-col>
      <b-col lg="6">
        <referrers />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { reload } from '@/libs/boot'
import Channels from '@/views/dashboard/components/Channels.vue'
import Referrers from '@/views/dashboard/components/Referrers.vue'
import Shortcodes from '@/views/dashboard/components/Shortcodes.vue'
import Visits from './components/Visits.vue'

export default {
  components: {
    Channels,
    Referrers,
    Visits,
    Shortcodes
  },
  data() {
    return {
      ready: false
    }
  },
  async beforeMount() {
    await reload()
    this.ready = true
  }
}
</script>
